<template>
    <Tabs
        :model-value="active"
        class="w-full"
        @update:model-value="onTabChange"
    >
        <TabsList class="h-auto w-full">
            <TabsTrigger value="subscription" class="h-auto flex-1">
                Subscription
            </TabsTrigger>
            <TabsTrigger value="invoices" class="h-auto flex-1">
                Invoices
            </TabsTrigger>
        </TabsList>
    </Tabs>
</template>

<script lang="ts" setup>
import { PropType } from 'vue';
import { router } from '@inertiajs/vue3';
import { route } from 'ziggy-js';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';

defineProps({
    active: {
        type: String as PropType<'subscription' | 'invoices'>,
        required: true,
    },
});

const onTabChange = (value: string | number) => {
    const target = String(value);
    if (target === 'subscription') {
        router.get(route('billing.plugin-subscriptions.index'));
    } else if (target === 'invoices') {
        router.get(route('billing.invoices.index'));
    }
};
</script>
